import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { highlight } from '@docpocalypse/code-live';

function ComponentImport(_ref) {
  var importName = _ref.importName,
      _ = _ref.docNode,
      props = _objectWithoutPropertiesLoose(_ref, ["importName", "docNode"]);

  return /*#__PURE__*/React.createElement("code", Object.assign({}, props, {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: highlight(importName, 'js')
    }
  }));
}

export default ComponentImport;